import { getEnvironment } from './environment.data';

export const environment = {
  production: true,
  ...getEnvironment('production'),
}
